import { useQuery, QueryFunction } from 'react-query';
import {
    getAllGnrSuppliers,
    GnrSupplier,
    GnrSupplierResponse,
    GnrSuppliersListResponse,
    getGnrSupplierById,
    GetGnrSupplierQueries,
} from '../../services/apiSLTP/sites/gnrSuppliers';

type UseGnrSuppliersQueryOptions = {
    queries?: GetGnrSupplierQueries;
};

const getGnrSuppliers: QueryFunction<GnrSuppliersListResponse> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseGnrSuppliersQueryOptions];
    const { queries } = options;

    const response = await getAllGnrSuppliers(queries);
    return response;
};

export const useGnrSuppliersQuery = (options: UseGnrSuppliersQueryOptions) => {
    return useQuery(['gnrSuppliers', options], getGnrSuppliers);
};

type UseGnrSupplierByIdQueryOptions = {
    includeFiles?: boolean;
};

const getGnrSupplierByIdQuery: QueryFunction<GnrSupplierResponse> = async ({ queryKey }) => {
    const [, id, options] = queryKey as [string, string, UseGnrSupplierByIdQueryOptions];
    const { includeFiles } = options;

    const response = await getGnrSupplierById(id);
    return response;
};

export const useGnrSupplierByIdQuery = (id: string, options: UseGnrSupplierByIdQueryOptions) => {
    return useQuery(['gnrSupplierById', id, options], getGnrSupplierByIdQuery);
};
